import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Nav_Interface, Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { Empty_User_Interface } from 'src/app/Interface/User_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { RoleService } from 'src/app/Service/Role/Role.service';

@Component({
  selector: 'app-RoleForm',
  templateUrl: './RoleForm.component.html',
  styleUrls: ['./RoleForm.component.scss']
})
export class RoleFormComponent implements OnInit {

  @Input() inner_Role:General_Interface=Empty_General_Interface()

  @Output() outter_Role= new EventEmitter<number>();

  Token:String=""
  InProccessing: boolean = false
  modalRef_Delete: any;
  page:any

  constructor(
    private Role_Service: RoleService,
    private modalService: BsModalService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.Token = localStorage.getItem('Daro_User_Token');

    this.RoleForm=new FormGroup({
      id :new FormControl(),
      title:new FormControl(null,Validators.required),
    })
    this.get_Form_title().setValue(this.inner_Role.title+'')

    this.Read_Data_Menu()
  }

  //#region  Form Add

  RoleForm:FormGroup;

  get_Form_title(){
    return this.RoleForm.get('title') as FormControl;
  }

  //#endregion

  OnSubmit() {

    var temp: General_Interface = Empty_General_Interface()
    temp.id = this.inner_Role.id
    temp.title = this.get_Form_title().value

    var SelectedMenu: Array<number> = []
    for (let lvl1 of this.Data_List_Menu) {
      for (let item of lvl1.child) {
        if (item.selected) {
          SelectedMenu.push(item.id)
        }
      }
    }

    var SelectedUSerRole: Array<string> = []
    for (let item of this.Data_List_Letter_Role) {
      if (item.selected) {
        SelectedUSerRole.push(item.icon)
      }
    }


    var SelectedTicketCategory: Array<number> = []
    for (let item of this.TicketCategory_DataList) {
      if (item.selected) {
        SelectedTicketCategory.push(item.id)
      }
    }

    var SelectedDeviceBehfaRepair: Array<number> = []
    if (this.First_DeviceBehfa.selected) {
      SelectedDeviceBehfaRepair.push(1)
    }
    if (this.Seond_DeviceBehfa.selected) {
      SelectedDeviceBehfaRepair.push(2)
    }
    if (this.Third_DeviceBehfa.selected) {
      SelectedDeviceBehfaRepair.push(3)
    }


    var SelectedDeviceBehfaRole: Array<number> = []
    for (let item of this.Data_List_DeviceBehfa_Role) {
      if (item.selected) {
        SelectedDeviceBehfaRole.push(Number(item.icon))
      }
    }

    var SelectedDataEntity: Array<number> = []
    for (let item of this.DataEntity_DataList) {
      if (item.selected) {
        SelectedDataEntity.push(Number(item.id))
      }
    }



    this.InProccessing=true
    this.Role_Service.addeditRole(temp,this.Token,
      SelectedMenu,
        SelectedUSerRole,
        SelectedDeviceBehfaRole,
        SelectedTicketCategory,
        SelectedDataEntity,
        SelectedDeviceBehfaRepair).subscribe(
      data=>{
        this.InProccessing=false

        this.Alertify_Service.SuccessMessage('Information saved successfully.')
        if(this.inner_Role.id==0)
          this.RoleForm.reset()
      }
    )


  }


  //#region Nav

  Read_Data_Menu() {
    this.Role_Service.GetNav(this.Token, this.inner_Role.id, false).subscribe(
      data => {
        this.Data_List_Menu = data
        this.Data_List_Menu = this.FilterNav(0)
        this.Read_Data_Letter_Role()
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  FilterNav(id: Number): Array<Nav_Interface> {
    var tempList: Array<Nav_Interface> = []
    for (let item of this.Data_List_Menu) {
      if (item.parent == id) {
        var temp: Nav_Interface = Empty_Nav_Interface()
        temp.id = item.id
        temp.icon = item.icon
        temp.link = item.link
        temp.parent = item.parent
        temp.selected = item.selected
        temp.title = item.title
        temp.child = this.FilterNav(item.id)

        tempList.push(temp)
      }

    }
    return tempList


  }

  Data_List_Menu_Change(id: Nav_Interface) {
    id.selected = !id.selected
  }
  Data_List_Letter_Role: Array<Nav_Interface> = []
  Data_List_Menu: Array<Nav_Interface> = []
  
  //#endregion

  //#region Ticket Category

  TicketCategory_DataList: Array<Nav_Interface>
  Read_TicketCategory() {
    this.InProccessing = true
    this.Role_Service.GetTicketCategoryUser(this.inner_Role.id, this.Token).subscribe(
      data => {
        this.Read_Repair_DeviceBehfa()
        this.InProccessing = false
        this.TicketCategory_DataList = data
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  //#endregion

  //#region Repair Device Behfa

  First_DeviceBehfa: Nav_Interface = Empty_Nav_Interface()
  Seond_DeviceBehfa: Nav_Interface = Empty_Nav_Interface()
  Third_DeviceBehfa: Nav_Interface = Empty_Nav_Interface()
  Read_Repair_DeviceBehfa() {
    this.Role_Service.GetDeviceBehfaRepairRole(this.Token, this.inner_Role.id).subscribe(
      data => {
        this.First_DeviceBehfa.selected = data['first_answer']
        this.Seond_DeviceBehfa.selected = data['second_answer']
        this.Third_DeviceBehfa.selected = data['third_answer']
        this.Read_DeviceBehfa_Role()
      }
    )
  }

  Data_List_DeviceBehfa_Role: Array<Nav_Interface> = []
  Read_DeviceBehfa_Role() {
    this.Role_Service.GetDeviceBehfaRole(this.inner_Role.id, this.Token).subscribe(
      data => {
        this.Data_List_DeviceBehfa_Role = data
        this.Read_DataEntity()
      }
    )
  }

  //#endregion

  //#region Letter

  Read_Data_Letter_Role() {
    this.Role_Service.GetLetterRole(this.inner_Role.id, this.Token).subscribe(
      data => {
        this.Data_List_Letter_Role = data
        this.Read_TicketCategory()
      }
    )
  }

  //#endregion

  //#region DataEntity

  DataEntity_DataList: Array<Nav_Interface>
  Read_DataEntity() {
    this.InProccessing = true
    this.Role_Service.GetDataEntity(this.inner_Role.id, this.Token).subscribe(
      data => {

        this.InProccessing = false
        this.DataEntity_DataList = data
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  //#endregion


  onBack(){
    this.outter_Role.emit(-1);
  }

}
